export const TEXT_AREA_MAX_HEIGHT = '232px';
